import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=c54bfbe0&scoped=true&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./spinner.scss?vue&type=style&index=0&id=c54bfbe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54bfbe0",
  null
  
)

export default component.exports